"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionPlugin = void 0;
const BasePlugin_1 = require("./BasePlugin");
class ConditionPlugin extends BasePlugin_1.BasePlugin {
    execute(list, _activities, _groups, conditions, _selected) {
        const conditionCount = new Map(conditions.map((condition) => {
            return [
                condition.id,
                { selected: 0, maximum: condition.maximum },
            ];
        }));
        for (const item of list) {
            // if activity is in selected array we count it
            if (item.registered) {
                const conditionId = item.activity_condition_id;
                if (!conditionId)
                    continue;
                const entry = conditionCount.get(conditionId);
                if (entry) {
                    entry.selected++;
                }
            }
        }
        for (const item of list) {
            const conditionId = item.activity_condition_id;
            if (!conditionId) {
                continue;
            }
            const entry = conditionCount.get(conditionId);
            // if equal to maximum only disable which are open for select
            if (entry &&
                entry.selected === entry.maximum &&
                this._isOpenForSelect(item)) {
                item.disabled = true;
                continue;
            }
            // if greater than maximum disabled all of them (This is fraudulent behaviour)
            if (entry && entry.selected > entry.maximum) {
                item.disabled = true;
            }
        }
        return list;
    }
}
exports.ConditionPlugin = ConditionPlugin;
